module.exports = __webpack_public_path__ + "media/images/emblems/Zuzwil-coat_of_arms-44a3cc60b0d309cecfc974df00fe8f12.svg";